import useControlledState from '@/hooks/useControlledState.mjs'
import useObserveState from '@/hooks/useObserveState.mjs'

const predefinedConfig = ({
    align,
    backgroundColor,
    color,
    fixed,
    hidden,
    width,
}) => ({
    align,
    backgroundColor,
    color,
    fixed,
    hidden,
    width,
})

const normalizeColumnsConfig = (columns, columnConfigs = []) => {
    const normalizedConfig = []

    const idToColumn = new Map(
        columns.map(e => [e.key ?? e.dataIndex, e])
    )

    const configIds = new Set()

    for (const cc of columnConfigs) {
        const column = idToColumn.get(cc.id)

        if (column) {
            configIds.add(cc.id)

            normalizedConfig.push({
                ...predefinedConfig(column),
                ...cc,
            })
        }
    }

    for (const c of columns) {
        const id = c.key ?? c.dataIndex

        if (! configIds.has(id)) {
            normalizedConfig.push({id, ...predefinedConfig(c)})
        }
    }

    return normalizedConfig
}

const normalizeConfig = (columns, config) => {
    if (config) {
        return {
            columns: normalizeColumnsConfig(columns, config.columns),
            pagination: config.pagination ?? {},
            striped: config.striped ?? false,
        }
    }
}

export default (columns, controlledConfig, onChangeConfig) => {
    const [_config, _setConfig] = useControlledState(
        {},
        controlledConfig,
        onChangeConfig
    )

    const config = normalizeConfig(columns, _config)
    const [setConfig, useConfig] = useObserveState(config, _setConfig)

    const setColumnConfig = (id, x) => {
        setConfig(config => {
            const i = config.columns.findIndex(e => id === e.id)

            if (- 1 < i) {
                const column = config.columns[i]
                const cfg = 'function' === typeof x ? x(column) : x
                const columns = config.columns.toSpliced(i, 1, {...cfg, id})
                return {...config, columns}
            }
            else {
                throw new Error(`未找到列设置: ${id}`)
            }
        })
    }

    const useColumnConfig = id => {
        const {columns} = useConfig()
        return columns.find(e => id === e.id)
    }

    return {
        config,
        setConfig,
        setColumnConfig,
        useColumnConfig,
        useConfig,
    }
}
